if (!customElements.get('product-form-bundle')) {
  customElements.define('product-form-bundle', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['Content-Type'];

      // === Construct Form data

      // --- Bundle form data
      
      let items = [];
      const bundle_id = Date.now();
      const bundle_items_length = this.getAttribute('data-bundle-length');
      const bundle_discount = this.getAttribute('data-bundle-discount-percent');
      let bundle_price = ''
      if (this.getAttribute('data-bundle-price') !== null){
        bundle_price = this.getAttribute('data-bundle-price');
      } else {
        bundle_price = document.querySelector('[data-bundle-price]')?.getAttribute('data-bundle-price');
      }
      let bundle_composition_skus = '';

      // Bundle childs
      const bundleVariantsInputSelected = document.querySelectorAll(`bundle-variant-selectors[data-section="${this.dataset.section}"] input:checked`);
      if (bundleVariantsInputSelected.length > 0) {
        bundleVariantsInputSelected.forEach(bundleVariantInputSelected => {
          const child_variant_id = bundleVariantInputSelected.getAttribute('data-variant-id');
          const child_variant_quantity = bundleVariantInputSelected.getAttribute('data-variant-quantity') || 1;
          // console.log(child_variant_quantity);
          // console.log(child_variant_id);
          // console.log('bundleVariantInputSelected', bundleVariantInputSelected)
          if (child_variant_id !== null && child_variant_id !== undefined) {
            const child_properties = {
              '_is_bundle_child': true,
              '_bundle_id': bundle_id,
              '_bundle_length': parseInt(bundle_items_length),
              '_bundle_discount': parseFloat(bundle_discount)
            };
            items.push(
              {
                id: child_variant_id,
                quantity: child_variant_quantity,
                properties: child_properties
              }
            );
          }
          const child_variant_sku = bundleVariantInputSelected.getAttribute('data-variant-sku');
          if (child_variant_sku !== null && child_variant_sku !== undefined) {
            if (bundle_composition_skus !== '') {
              bundle_composition_skus += `, ${child_variant_sku}`;
            } else {
              bundle_composition_skus += `${child_variant_sku}`;
            }
          }
        });
      }

      // Bundle parent
      const parent_variant_id = this.form.querySelector('input[name=id]').value;
      if (parent_variant_id !== null && parent_variant_id !== undefined) {
        const parent_properties = {
          '_is_bundle_parent': true,
          '_bundle_id': bundle_id,
          '_bundle_length': parseInt(bundle_items_length),
          '_bundle_discount': parseFloat(bundle_discount),
          '_bundle_price': bundle_price,
          '_bundle_composition_skus': bundle_composition_skus
        };
        items.push(
          {
            id: parent_variant_id,
            quantity: 1,
            properties: parent_properties
          }
        );
      }

      const formData = {
        'items': items
      };

      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });

      // === GTM Product add
      if (this.submitButton && this.submitButton.hasAttribute('data-gtm-product-add')) {
        const dataEvent = JSON.parse(this.submitButton.getAttribute('data-gtm-product-add'));
        if (dataEvent.productPriceArr && document.querySelector('[data-bundle-price]')) {
          let price = document.querySelector('[data-bundle-price]')?.getAttribute('data-bundle-price');
          if (price) {
            price = parseInt(price);
            price = (price / 100).toFixed(2);
            dataEvent.productPriceArr = [`${price}`];
          }
        }
        const evt = new CustomEvent("gtmProductAdd", {'detail': dataEvent});
        window.dispatchEvent(evt);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
